import StringUtils from './StringUtils';

function validateNumber(number) {
  if (isNaN(number)) {
    return 0;
  }
  return number;
}

var ConversionUtils = {
  kilometersToMeters: function (km) {
    return validateNumber(km * 1000);
  },

  metersToKilometers: function (m) {
    return validateNumber(m / 1000);
  },

  milesToMeters: function (mi) {
    return validateNumber(mi * 1609.33999997549);
  },

  metersToMiles: function (meters) {
    return validateNumber(meters / 1609.33999997549);
  },

  feetToMeters: function (feet) {
    return validateNumber(feet * 0.3048);
  },

  inchesToMeters: function (inches) {
    return validateNumber(inches * 0.0254);
  },

  yardsToMeters: function (yards) {
    return validateNumber(yards * 0.9144);
  },

  nauticalMilesToMeters: function (nmi) {
    return validateNumber(nmi * 1852);
  },

  metersToNauticalMiles: function (meters) {
    return validateNumber(meters / 1852);
  },

  metersToFeet: function (meters) {
    return validateNumber(3.28084 * meters);
  },

  metersPerHourToKnots: function (metersPerHour) {
    return validateNumber(metersPerHour * 0.000539957);
  },

  poundsToGrams: function (pounds) {
    return validateNumber(pounds * 453.592);
  },

  kilogramsToPounds: function (kg) {
    return kg * 2.20462;
  },

  kilogramsToGrams: function (kg) {
    return kg * 1000;
  },

  gramsToKilograms: function (grams) {
    return grams / 1000;
  },

  milligramsToPounds: function (mg) {
    return mg * 2.2046e-6;
  },

  milligramsToGrams: function (mg) {
    return mg / 1000;
  },

  gramsToMilligrams: function (grams) {
    return grams * 1000;
  },

  gramsToPounds: function (g) {
    return g * 0.00220462;
  },

  ouncesToPounds: function (ounces) {
    return ounces * 0.0625;
  },

  centimetersToInches: function (centimeters) {
    return validateNumber(0.393701 * centimeters);
  },

  inchesToCentimeters: function (inches) {
    return validateNumber(inches / 0.393701);
  },

  ouncesToGrams: function (ounces) {
    return ounces * 28.3495;
  },

  gramsToOunces: function (grams) {
    return grams / 28.3495;
  },

  knotsToKilometersPerHour: function (knots) {
    return knots * 1.852;
  },

  kilometersPerHourToKnots: function (kmph) {
    return kmph / 1.852;
  },

  stringToGrams: function (string) {
    var numValue = parseFloat(string);
    if (StringUtils.endsWith(string.toLowerCase(), 'g')) {
      string = string.substr(0, string.length - 1).trim();
      numValue = parseFloat(string);
    } else if (StringUtils.endsWith(string.toLowerCase(), 'lbs')) {
      string = string.substr(0, string.length - 3).trim();
      numValue = this.poundsToGrams(parseFloat(string));
    } else if (StringUtils.endsWith(string.toLowerCase(), 'kg')) {
      string = string.substr(0, string.length - 2).trim();
      numValue = this.kilogramsToGrams(parseFloat(string));
    } else if (StringUtils.endsWith(string.toLowerCase(), 'mg')) {
      string = string.substr(0, string.length - 2).trim();
      numValue = this.milligramsToGrams(parseFloat(string));
    } else if (StringUtils.endsWith(string.toLowerCase(), 'oz.')) {
      string = string.substr(0, string.length - 3).trim();
      numValue = this.ouncesToGrams(parseFloat(string));
    } else if (StringUtils.endsWith(string.toLowerCase(), 'oz')) {
      string = string.substr(0, string.length - 2).trim();
      numValue = this.ouncesToGrams(parseFloat(string));
    }
    return isNaN(numValue) ? 0 : numValue;
  },

  stringToMeters: function (string) {
    var numValue = parseFloat(string);
    if (StringUtils.endsWith(string.toLowerCase(), 'km')) {
      string = string.substr(0, string.length - 2).trim();
      numValue = this.kilometersToMeters(parseFloat(string));
    } else if (StringUtils.endsWith(string.toLowerCase(), 'nmi')) {
      string = string.substr(0, string.length - 3).trim();
      numValue = Math.round(this.nauticalMilesToMeters(parseFloat(string)));
    } else if (StringUtils.endsWith(string.toLowerCase(), 'yd')) {
      string = string.substr(0, string.length - 2).trim();
      numValue = Math.round(this.yardsToMeters(parseFloat(string)));
    } else if (StringUtils.endsWith(string.toLowerCase(), 'mi')) {
      string = string.substr(0, string.length - 2).trim();
      numValue = Math.round(this.milesToMeters(parseFloat(string)));
    } else if (
      StringUtils.endsWith(string.toLowerCase(), "''") ||
      StringUtils.endsWith(string.toLowerCase(), 'in')
    ) {
      string = string.substr(0, string.length - 2).trim();
      numValue = Math.round(this.inchesToMeters(parseFloat(string)));
    } else if (
      StringUtils.endsWith(string.toLowerCase(), "'") ||
      StringUtils.endsWith(string.toLowerCase(), 'ft')
    ) {
      if (StringUtils.endsWith(string.toLowerCase(), "'")) {
        string = string.substr(0, string.length - 1).trim();
      } else {
        string = string.substr(0, string.length - 2).trim();
      }

      numValue = Math.round(this.feetToMeters(parseFloat(string)));
    } else if (StringUtils.endsWith(string.toLowerCase(), 'm')) {
      string = string.substr(0, string.length - 1).trim();
      numValue = parseFloat(string);
    }
    return isNaN(numValue) ? 0 : numValue;
  },

  /**
   * Convert a pair of `topLeft`/`bottomRight` locations
   * to a standard extent (`[[minX, minY],[maxX, maxY]]`)
   * @param {Location} topLeft the top left location
   * @param {Location} bottomRight the top left location
   * @return {[[number, number],[number, number]]} extent
   */
  locationPairToExtent: (topLeft, bottomRight) => {
    return [
      [topLeft.longitude, bottomRight.latitude],
      [bottomRight.longitude, topLeft.latitude],
    ];
  },
};

export default ConversionUtils;
